module.exports = __webpack_public_path__ + "static/media/data_science.b67300d8.svg";